import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../apis/api";
import { loadingEnd, loadingStart } from "../setLoading/setLoading";
export const inspirationGetList = createAsyncThunk(
  "inspirationGetList/get",
  async (data, { rejectWithValue, dispatch }) => {
    dispatch(loadingStart());
    const backend = new API();
    try {
      const response = await backend.fetch(API.inspirationGetList(), {
        method: "GET",
      });
      let inspirationList = [];

      if (response.data.length > 0) {
        response.data.map((value, index) => {
          if (
            value?.is_active === 1 &&
            value?.product_variant?.model === data
          ) {
            inspirationList.push(value);
          }
          return null;
        });
      }
      dispatch(loadingEnd());
      // You may want to return some data here if needed
      return inspirationList;
    } catch (error) {
      dispatch(loadingEnd());
      console.error("Error creating user:", error);
      // You can handle the error here or throw it again if needed
      return rejectWithValue(error);
    }
  }
);
